import Skeleton from '@mui/material/Skeleton';
import { PropsWithChildren } from 'react';
import { useId } from '../../../../lib/hooks/useId';
import styles from './UserPreferences.module.scss';
import { userPreferencesIds } from '../../../../lib/tests/testIds';

type UserPreferencesSkeletonProps = PropsWithChildren<{ withSubtitle?: boolean; isLoading: boolean }>;

export const UserPreferenceSkeleton = ({ withSubtitle, isLoading, children }: UserPreferencesSkeletonProps) => {
  const id = useId();

  if (!isLoading) {
    return children;
  }

  return (
    <div className={styles.skeleton} data-testid={userPreferencesIds.skeleton}>
      {withSubtitle && (
        <>
          <Skeleton className={styles.skeletonSubtitle} />
          <div className={styles.skeletonSpacer} />
        </>
      )}
      {Array.from({ length: 9 }, (_, index) => `${id}-${index + 1}`).map(key => (
        <Skeleton key={key} className={styles.skeletonRow} />
      ))}
    </div>
  );
};
